import { render } from "./BookNowBlock.vue?vue&type=template&id=6581d7ec&scoped=true"
import script from "./BookNowBlock.vue?vue&type=script&lang=js"
export * from "./BookNowBlock.vue?vue&type=script&lang=js"

import "./BookNowBlock.vue?vue&type=style&index=0&id=6581d7ec&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-6581d7ec"

export default script